import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  .MuiInputBase-root {
    padding-right: 10px;
  }

  .Mui-disabled {
    svg {
      color: ${theme.colors.neutral.mediumhover};
    }
  }
`

export const SearchResults = styled.div`
  background-color: ${theme.colors.neutral.white};
  position: absolute;
  width: 100%;
  z-index: 1000;
  top: 47px;
  left: 0;
  max-height: 200px;
  overflow-y: scroll;
  box-shadow: ${theme.effects.boxShadow['rule-01']};
  border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};
  border-radius: ${theme.shapes.borderRadius.sm};
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: ${theme.spacing.xs} 0 ${theme.spacing.sm} ${theme.spacing.sm};
`
export const SearchContent = styled.div`
  width: 100%;
`

export const SearchItem = styled.div`
  width: 100%;
  cursor: pointer;
  font-size: ${theme.typography.sizes.xs};
  border-radius: ${theme.shapes.borderRadius.sm};
  border: 1px solid ${theme.colors.quartenary};
  :not(:last-child) {
    margin-bottom: ${theme.spacing.xs};
  }
  :hover {
    background: ${theme.colors.quartenary};
  }
  padding: ${theme.spacing.xs} 0 ${theme.spacing.xs} ${theme.spacing.xs};
`
